import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native'

// utils
import { Svg, Path } from '../../utils/svg'

import { defaults } from './index'

export default class SelectSub extends Component {
  state = {
    color: defaults.COLOR,
    backgroundColor: defaults.BACKGROUND_COLOR,
    isOpen: false,
  }

  componentDidMount() {
    this.handleColor()
    this.handleBackgroundColor()
  }

  componentDidUpdate(prevProps) {
    const { object, value } = this.props

    if (prevProps.value !== value) {
      this.handleColor()
    }

    if (prevProps.object.attributes !== object.attributes) {
      this.handleColor()
      this.handleBackgroundColor()
    }
  }

  static contextTypes = {
    openSelect: PropTypes.func,
    cancelSelect: PropTypes.func,
  }

  static defaultProps = {
    options: [],
  }

  handleColor = () => {
    const { object, value } = this.props
    const { attributes } = object
    const { color } = attributes

    if (value && value !== '_placeholder') {
      this.setState({ color })
    } else {
      this.handlePlaceholderColor()
    }
  }

  handlePlaceholderColor = () => {
    const { object } = this.props
    const { attributes } = object
    const { placeholderColor } = attributes

    if (placeholderColor) {
      this.setState({ color: placeholderColor })
    } else {
      this.setState({ color: defaults.COLOR })
    }
  }

  handleBackgroundColor = () => {
    const { object } = this.props
    const { attributes } = object

    const { backgroundColor } = attributes

    if (backgroundColor) {
      this.setState({ backgroundColor })
    } else {
      this.setState({ backgroundColor: defaults.BACKGROUND_COLOR })
    }
  }

  handleChange = value => {
    const { onChange } = this.props

    this.setState({ isOpen: false })

    if (value === '_placeholder') {
      value = null
    }

    onChange(value)
  }

  handleCancel = () => {
    this.setState({ isOpen: false })
  }

  handleOpen = () => {
    const { options, value } = this.props
    const { openSelect } = this.context

    this.setState({ isOpen: true })

    openSelect(options, value, this.handleChange, this.handleCancel)
  }

  componentWillUnmount() {
    const { isOpen } = this.state
    const { cancelSelect } = this.context

    if (isOpen) {
      cancelSelect()
    }
  }

  render() {
    let { object, options, value, style } = this.props
    const { backgroundColor, color } = this.state

    const { height, padding, placeholder, borderRadius } = object.attributes

    const wrapperStyles = {
      paddingLeft: padding,
      paddingRight: padding,
      height,
      borderRadius,
      backgroundColor,
      borderStyle: style.borderStyle,
      borderWidth: style.borderWidth,
      borderColor: style.borderColor,
      opacity: style.opacity,
    }

    const inputStyles = {
      fontSize: style.fontSize,
      fontWeight: style.fontWeight,
      fontFamily: style.fontFamily,
      color,
    }

    if (!value) {
      value = '_placeholder'
    }

    const currentOption = options.find(opt => opt.value === value)

    const label =
      (currentOption && currentOption.label) || placeholder || 'Select...'

    return (
      <TouchableOpacity onPress={this.handleOpen}>
        <View style={[styles.main, wrapperStyles]}>
          <Text style={[styles.text, inputStyles]}>{label}</Text>
          <View style={styles.carrot}>
            <Svg width={10} height={50}>
              <Path
                d="M 0 0 L 10 0 L 5 5 Z"
                fill="rgba(0, 0, 0, 0.2)"
                stroke="none"
              />
            </Svg>
          </View>
        </View>
      </TouchableOpacity>
    )
  }
}

const styles = StyleSheet.create({
  main: {
    backgroundColor: '#eee',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  carrot: {
    width: 10,
    height: 5,
  },
})
